import { render, staticRenderFns } from "./BuildingsAndRooms.vue?vue&type=template&id=5fe95d17&"
import script from "./BuildingsAndRooms.vue?vue&type=script&lang=js&"
export * from "./BuildingsAndRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports